import { DATA_REQUEST_ASYNC, SELECT_TOGGLE, UPDATE_DATA_REQUEST_ASYNC } from './constants'

export const fetchVipUsers = () => ({ type: DATA_REQUEST_ASYNC.INITIATE })
const fetchVipUsersCancel = () => ({ type: DATA_REQUEST_ASYNC.CANCEL })
export const fetchVipUsersSuccess = (data) => ({
  type: DATA_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchVipUsersError = (error) => ({
  type: DATA_REQUEST_ASYNC.ERROR,
  error,
})

export const updateVipUsersEpic = (data) => ({
  type: UPDATE_DATA_REQUEST_ASYNC.INITIATE,
  payload: { data },
})
export const updateVipUsersEpicSuccess = () => ({
  type: UPDATE_DATA_REQUEST_ASYNC.SUCCESS,
})
export const updateVipUsersEpicError = (error) => ({
  type: UPDATE_DATA_REQUEST_ASYNC.ERROR,
  error,
})

const toggleSelect = (id) => ({ type: SELECT_TOGGLE, payload: { id } })

export default {
  // to props
  fetchVipUsers,
  fetchVipUsersCancel,
  toggleSelect,
  updateVipUsersEpic,
}
